import { SvgBase } from "../svg.base";

export const Time = () => (
  <SvgBase>
    <path
      fill="currentColor"
      d="M14.99 5C20.52 5 25 9.48 25 15s-4.48 10-10.01 10C9.47 25 5 20.52 5 15S9.47 5 14.99 5zM15 23c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm.5-13v5.25l4.5 2.67-.75 1.23L14 16v-6h1.5z"
    />
  </SvgBase>
);



